export default {
  locationChanged: state => {
    const { shared, quote } = state
    const quoteZipcode = quote.lead?.zipcodeId
    return quoteZipcode && shared.zipcode !== quoteZipcode
  }
}
